/** Bucket ISO timestamps into last N days (oldest → newest) */
export function bucketLastNDays(timestamps: string[], days = 7): number[] {
  const buckets = Array(days).fill(0) as number[];
  const now = new Date();
  now.setHours(23, 59, 59, 999);

  for (const iso of timestamps) {
    const t = new Date(iso).getTime();
    if (Number.isNaN(t)) continue;
    const diffDays = Math.floor((now.getTime() - t) / (24 * 60 * 60 * 1000));
    if (diffDays >= 0 && diffDays < days) {
      buckets[days - 1 - diffDays] += 1;
    }
  }
  return buckets;
}
